import { Base } from '@studiometa/js-toolkit';

/**
 * Addresses component
 */
export default class Addresses extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Addresses',
    refs: [
      'editAddressCancelLink',
      'editAddressForm',
      'editAddressLink',
      'addAddressForm',
      'addAddressLink',
      'addAddressLinkCancel',
    ],
  };

  /**
   * On click
   */
  onEditAddressLinkClick() {
    this.$refs.editAddressForm.classList.remove('hidden');
  }

  /**
   *
   */
  onEditAddressCancelLinkClick() {
    this.$refs.editAddressForm.classList.add('hidden');
  }

  /**
   *
   */
  onAddAddressLinkClick() {
    this.$refs.addAddressForm.classList.remove('hidden');
  }

  /**
   *
   */
  onAddAddressLinkCancelClick() {
    this.$refs.addAddressForm.classList.add('hidden');
  }
}
